'use client';
import { Box } from '@mui/material';
import ShareSocialIcons from 'components/share-icons';
import { PostHeroImage } from './post-hero-image';
import { PostHeroTitle } from './post-hero-title';
import { theme } from '../../../../styles';
import { PostAuthor, PostCategories } from '../index';
import { PublicationDate } from '../../../../components/publication-date/publication-date';

const ACFPostHero = ({ data }) => {
  return (
    <>
      {data != null ? (
        <div className="postHero">
          {data.featuredImage != null && (
            <PostHeroImage title={data.title} sourceUrl={data.featuredImage.node.sourceUrl} />
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              zIndex: 2,
              width: '100%',
              maxWidth: '1200px',
              paddingX: '1rem',
              paddingTop: '0.75rem',
              margin: '0 auto',
              [theme?.breakpoints?.up('xlg')]: {
                padding: 0,
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '0.75rem',
                position: 'relative',
                [theme?.breakpoints?.up('xmd')]: {
                  marginBottom: '2rem',
                },
              }}
            >
              {data.title != null && <PostHeroTitle title={data.title} />}
              <Box
                sx={{
                  position: 'absolute',
                  right: 0,
                  top: -70,
                  [theme?.breakpoints?.up('xmd')]: {
                    position: 'static',
                  },
                }}
              >
                <ShareSocialIcons className="socialIcons desktop"></ShareSocialIcons>
              </Box>
            </Box>
            <div className="category">
              <PublicationDate date={data.date} />
              {data.categories != null && <PostCategories categories={data.categories.nodes} />}
              {data.author && (
                <PostAuthor data={data.author.node} sxStyles={{ marginTop: { xs: '12px', xlg: '3px' } }} />
              )}
            </div>
          </Box>
        </div>
      ) : null}
    </>
  );
};
export default ACFPostHero;
